/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * Mouse position helpers
 */
export class MousePosUtils {
    /**
     * @returns relative mouse coordinates [-1...1]
     */
    static readRelMousePos(event, element) {
        const { left, top, width, height } = element.getBoundingClientRect();
        const mousex = ((event.clientX - left) / width) * 2 - 1;
        const mousey = -((event.clientY - top) / height) * 2 + 1;
        return { mousex, mousey };
    }
}
//# sourceMappingURL=MousePosUtils.js.map